/**
 * PushModeListToExtra Handler для HeaderPage
 * 
 * Додає перемикач режимів відображення (таблиця/картки) в afterExtra
 */

import React from 'react'
import { Segmented, Tooltip } from 'antd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react-lite'

/**
 * Додає перемикач режимів відображення в afterExtra
 * 
 * @param params - параметри з headerPageContext
 */
export const PushModeListToExtra = ({ headerPageContext }: any) => {
    const crudContext = headerPageContext?.storages?.crudContext
    const defaultLayoutContext = headerPageContext?.storages?.defaultLayoutContext

    if (!crudContext) return

    headerPageContext.afterExtra ??= []

    /**
     * Observer компонент — будує options реактивно з variantItems,
     * тому відображається навіть якщо варіанти додані після ініціалізації headerPage.
     */
    const ModeListObserver = observer(() => {
        const variantItems = toJS(crudContext?.listContext?.variantItems ?? {})
        const keys = Object.keys(variantItems)

        if (keys.length <= 1) return null

        if (defaultLayoutContext?.isMobileMode) {
            if (crudContext.listContext.variant !== 'table') {
                crudContext.listContext.setVariant('table')
            }
            return null
        }

        const options: any[] = keys.map((key) => {
            const item = variantItems[key]
            const Icon = item.icon ?? (() => {})
            return {
                key,
                label: null,
                value: key,
                icon: React.createElement(
                    Tooltip,
                    { placement: 'top', title: item.label },
                    React.createElement(
                        'div',
                        { style: { position: 'relative', top: 5 } },
                        React.createElement(Icon, { style: { fontSize: 24 } })
                    )
                ),
            }
        })

        options.reverse()

        return React.createElement(Segmented, {
            value: crudContext.listContext.variant,
            size: 'middle',
            options: options,
            onChange: (value: unknown) => {
                crudContext.listContext.setVariant(value as string)
            },
        })
    })

    headerPageContext.afterExtra.push(
        React.createElement(
            'div',
            { key: 'crudresource-modelist-headerpage' },
            React.createElement(ModeListObserver)
        )
    )
}
